<template >
    <div class="qr-scanner-wrapper">
        <span class="qr-scanner-close" @click="isQrScanner = false">
            <img src="@/assets/img/ico_close_lan.png" alt="close" style="width: 20px; height: 20px" />
        </span>
        <input @paste="onPasteURI" v-model="uri" :placeholder="$t('home.inputUri')" type="text" />
        <div class="qr-or">OR</div>
        <button @click="isQrScan = true">{{$t('home.scan')}}</button>
        <QrScannerWrapper @scanned="qrScanned" @close="isQrScan = false" v-if="isQrScan"></QrScannerWrapper>
    </div>
</template>
<script>
import QrScannerWrapper from "./QrScannerWrapper.vue";
export default {
    data() {
        return {
            uri: "",
            isQrScan: false,
        };
    },
    methods: {
        onPasteURI(evt) {
            this.uri = evt.clipboardData.getData("text/plain");
            if (typeof this.uri == "string") {
                this.$emit("gotUri", this.uri);
                this.isQrScanner = false;
            }
        },
        qrScanned(val) {
            this.uri = val;
            if (typeof this.uri == "string") {
                this.$emit("gotUri", this.uri);
                this.isQrScan = false
                this.isQrScanner = false;
            }
        }
    },
    computed: {
        isQrScanner: {
            get() {
                return this.$store.state.isQrScanner;
            },
            set(value) {
                this.$store.dispatch("setIsQrScanner", value);
            }
        },
    },
    components: { QrScannerWrapper }
}
</script>
<style lang="scss" scoped>
.qr-scanner-wrapper {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden;
    background: whitesmoke;
    z-index: 50;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation:0.5s ease  jumpIn;

    input {
        display: flex;
        width: 70%;
        height: 40px;
        border-radius: 8px;
        border: 1px solid gray;
        align-items: center;
        padding-left: 8px;
        max-width: 400px;
    }

    .qr-or {
        margin: 20px;
        color: gray;
    }

    button {
        display: flex;
        width: 70%;
        height: 40px;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        background: #1296db;
        color: white;
        max-width: 400px;


    }

    .qr-scanner-close {
        position: absolute;
        top: 20px;
        right: 20px;
    }
}


@keyframes jumpIn {
    0% {
        transform: translateY(150%);

    }

    100% {
        transform: translateY(0%);

    }
}
</style>